/**
 * JitsLab Design Tokens — single source of truth.
 * Lifted directly from the v2.5 Zinc/Amber system.
 * Nothing new invented here; the uplift lives in motion.
 */

export const TOKENS = {
  // Surfaces
  bg: '#09090b',
  surface: '#18181b',
  field: '#27272a',
  border: '#27272a',
  borderLight: '#3f3f46',

  // Text
  textPrimary: '#f4f4f5',
  textSecondary: '#a1a1aa',
  textTertiary: '#71717a',

  // Accent
  amber: '#f59e0b',
  amberLight: '#fbbf24',
  amberSoft: 'rgba(245, 158, 11, 0.12)',

  // Feedback
  success: '#6ee7b7',
  successSoft: 'rgba(16, 185, 129, 0.16)',
  successBorder: 'rgba(52, 211, 153, 0.4)',
  danger: '#fca5a5',
} as const;

/** Badge colors per technique type */
export const BADGE: Record<string, { fg: string; bg: string }> = {
  position: { fg: '#93c5fd', bg: 'rgba(59, 130, 246, 0.18)' },
  guard: { fg: '#6ee7b7', bg: 'rgba(16, 185, 129, 0.18)' },
  pass: { fg: '#d8b4fe', bg: 'rgba(168, 85, 247, 0.18)' },
  sweep: { fg: '#fdba74', bg: 'rgba(249, 115, 22, 0.18)' },
  submission: { fg: '#fca5a5', bg: 'rgba(239, 68, 68, 0.18)' },
};

/** Font families */
export const FONTS = {
  display: "'Oswald', sans-serif",
  mono: "'JetBrains Mono', monospace",
  body: "system-ui, -apple-system, sans-serif",
} as const;

/** Spacing scale (px) */
export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

/** Border radii (px) */
export const RADII = {
  sm: 4,
  md: 8,
  lg: 10,
  xl: 12,
  pill: 999,
} as const;
